// extracted by mini-css-extract-plugin
export default {"page":"index_page__XwTp4","page__header":"index_page__header__LftEj","page__body":"index_page__body__Ktj5P"};